// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Erectile dysfunction (INITIAL) 09.17.26" (1dcb779e-562e-4b69-9242-e20afe682f65). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiErectileDysfunctionInitialQuestions = [
  {
    field: 'mdiErectileDysfunctionInitial_longIssuesSexualPerformance',
    label: 'How long have you had issues with sexual performance?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'o_0_6_months', value: '0-6 months' },
        { key: 'o_7_12_months', value: '7-12 months' },
        { key: 'more_than_a_year', value: 'More than a year' }
      ]
    },
    extras: { mdiQuestionId: '878fe71b-003f-4992-b28d-93edd30c484f' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_medicationsDevicesTried',
    label: 'Which medications/devices have you tried?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'viagra_sildenafil',
          value: 'Viagra (Sildenafil)',
          answer: {
            type: 'text',
            name: 'viagra_sildenafil_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'cialis_tadalafil',
          value: 'Cialis (Tadalafil)',
          answer: {
            type: 'text',
            name: 'cialis_tadalafil_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'levitra_vardenafil',
          value: 'Levitra (Vardenafil)',
          answer: {
            type: 'text',
            name: 'levitra_vardenafil_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'device_vacuum_pump_implants',
          value: 'Device (Vacuum Pump/Implants)',
          answer: {
            type: 'text',
            name: 'device_vacuum_pump_implants_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'other_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'NONE OF THE ABOVE' }
      ]
    },
    extras: { mdiQuestionId: 'b700f45c-f1a6-43a2-a5f1-352f592132fa' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_redFlagsApply',
    label: 'Do any of the following RED FLAGS apply to you?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'i_have_been_told_that_i_am_not_healthy_e',
          value: 'I have been told that I am not healthy enough to have sex.',
          answer: {
            type: 'text',
            name: 'i_have_been_told_that_i_am_not_healthy_e_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'within_the_last_year_i_have_experienced',
          value:
            'Within the last year I have experienced chest pain AND/OR significant shortness of breath while exercising',
          answer: {
            type: 'text',
            name: 'within_the_last_year_i_have_experienced_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'i_have_experienced_unexplained_blurry_vi',
          value: 'I have experienced unexplained blurry vision or headaches.',
          answer: {
            type: 'text',
            name: 'i_have_experienced_unexplained_blurry_vi_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'i_am_unable_to_walk_one_mile_on_a_flat_s',
          value: 'I am unable to walk one mile on a flat surface.',
          answer: {
            type: 'text',
            name: 'i_am_unable_to_walk_one_mile_on_a_flat_s_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'i_have_been_diagnosed_with_low_blood_pre',
          value: 'I have been diagnosed with “low blood pressure.”',
          answer: {
            type: 'text',
            name: 'i_have_been_diagnosed_with_low_blood_pre_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'NONE OF THE ABOVE' }
      ]
    },
    extras: { mdiQuestionId: 'c1f3704a-76ff-4058-96c8-6b4dda1303d3' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_redFlagConditions',
    label: 'Do you have any of the following RED FLAG conditions?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'retinitis_pigmentosa_or_anterior_ischemi',
          value: 'Retinitis pigmentosa or anterior ischemic optic neuropathy',
          answer: {
            type: 'text',
            name: 'retinitis_pigmentosa_or_anterior_ischemi_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'severe_aortic_stenosis_or_hypertrophic_o',
          value:
            'Severe aortic stenosis OR Hypertrophic obstructive cardiomyopathy (HOCM)',
          answer: {
            type: 'text',
            name: 'severe_aortic_stenosis_or_hypertrophic_o_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'pulmonary_hypertension',
          value: 'Pulmonary Hypertension',
          answer: {
            type: 'text',
            name: 'pulmonary_hypertension_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'sickle_cell_anemia_myeloma_or_leukemia',
          value: 'Sickle cell anemia, myeloma, or leukemia',
          answer: {
            type: 'text',
            name: 'sickle_cell_anemia_myeloma_or_leukemia_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'multiple_sclerosis_ms_or_similar_disease',
          value:
            'Multiple sclerosis (MS) or similar disease, spinal injuries or paralysis',
          answer: {
            type: 'text',
            name: 'multiple_sclerosis_ms_or_similar_disease_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'NONE OF THE ABOVE' }
      ]
    },
    extras: { mdiQuestionId: 'c6c4bfd7-c1f4-47db-9188-8a36558b4518' }
  },
  {
    field:
      'mdiErectileDysfunctionInitial_selectedPulmonaryHypertensionSureDiagnosis',
    label:
      'You selected Pulmonary Hypertension.  Are you sure you have this diagnosis?',
    type: 'select',
    educationalSlide:
      '• Pulmonary hypertension is NOT the same as Essential Hypertension\n• It is rather rare\n• It usually requires a specialist to diagnose (often after an echocardiography, an ultrasound of the heart)',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes_im_sure', value: "Yes I'm sure" },
        { key: 'no_im_not_sure', value: "No, I'm not sure" },
        {
          key: 'ooops_i_made_a_mistake_i_meant_essential',
          value: "Ooops, I made a mistake.  I meant 'essential hypertension'."
        }
      ]
    },
    extras: { mdiQuestionId: 'e8916b7a-bae4-4932-bce3-61874bcbc196' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_withinPast6MonthsHeart',
    label:
      'Within the past 6 months, have you had a heart attack or cardiac surgery?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_ive_had_a_recent_heart_attack_or_car',
          value: "Yes, I've had a recent heart attack or cardiac surgery",
          answer: {
            type: 'text',
            name: 'yes_ive_had_a_recent_heart_attack_or_car_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'e6faf269-fc78-4ddd-b93f-f5c36da5bda5' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_tellUsMoreAboutHappened',
    label: 'Can you tell us more about what happened?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionInitial_tellUsMoreAboutHappened',
      rows: 4,
      placeholder: 'Ex: I had a coronary stent placed one month ago'
    },
    extras: { mdiQuestionId: 'c1145464-3eb6-4188-bc16-105e75a27348' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_everPhysicalAbnormalitiesGenitals',
    label: 'Have you ever had any physical abnormalities with your genitals?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'previous_priapism_erection_lasting_longe',
          value:
            'Previous priapism (erection lasting longer than 4 hours requiring medical treatment)',
          answer: {
            type: 'text',
            name: 'previous_priapism_erection_lasting_longe_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'peyronies_disease',
          value: "Peyronie's Disease",
          answer: {
            type: 'text',
            name: 'peyronies_disease_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'significant_bend_in_penis_which_is_painf',
          value: 'Significant bend in penis which IS painful upon erection',
          answer: {
            type: 'text',
            name: 'significant_bend_in_penis_which_is_painf_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'genital_surgery_not_including_infant_cir',
          value:
            'Genital surgery (not including infant circumcision)/Pelvic trauma',
          answer: {
            type: 'text',
            name: 'genital_surgery_not_including_infant_cir_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'NONE OF THE ABOVE' }
      ]
    },
    extras: { mdiQuestionId: '9b30205e-f851-41b0-a2f1-6804388126fc' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_historyKidneyFailure',
    label: 'Do you have any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'history_of_kidney_failure_kidney_disease',
          value: 'History of kidney failure/kidney disease'
        },
        {
          key: 'have_seen_a_kidney_specialist_nephrologi',
          value: 'Have seen a kidney specialist (nephrologist)'
        },
        {
          key: 'severe_kidney_disease_stage_3_or_esrd_or',
          value: 'Severe kidney disease (stage 3 or ESRD or CrCl < 35)'
        },
        {
          key: 'previously_or_currently_on_dialysis',
          value: 'Previously or currently on dialysis'
        },
        { key: 'none_of_the_above', value: 'NONE of the above' }
      ]
    },
    extras: { mdiQuestionId: '18fdf8d9-4f56-40f9-b44b-1cf640451ccc' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_labTestsWithinPast6',
    label:
      'Have you had any lab tests within the past 6 months that include your renal function (Creatinine, CrCl, or GFR)?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'b47742de-5828-413c-8356-1b5cb4291463' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_uploadLabResults',
    label: 'Please upload lab results',
    type: 'file_upload',
    subLabel:
      '• If you are unable to provide at this time, your doctor may require you to upload your labs prior to prescribing medication.',
    accepts: [
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/png',
      'application/pdf'
    ],
    answer: [
      {
        resourceId: 'mdiErectileDysfunctionInitial_uploadLabResults',
        buttonLabel: 'Upload',
        required: false
      }
    ],
    required: false,
    extras: { mdiQuestionId: 'e600c0d1-f35a-4493-8852-78f89a41f3b0' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_provideDetailsMostRecentLab',
    label: 'Please provide details from your most recent lab test.',
    type: 'info',
    subLabel:
      '• If you were not able to upload a photo/file of your labs, please type them here.\n• We need information about your Creatinine, GFR, or CrCl.',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionInitial_provideDetailsMostRecentLab',
      rows: 4,
      placeholder: 'Ex: Creatinine 1.8. GFR 30'
    },
    extras: { mdiQuestionId: '3371db86-df4e-4365-87d8-0785043871e1' }
  },
  {
    field:
      'mdiErectileDysfunctionInitial_describeReasonsConsultationRenalKidney',
    label:
      'Please describe the reasons for your consultation with the renal/kidney specialist.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionInitial_describeReasonsConsultationRenalKidney',
      rows: 4,
      placeholder: 'Ex: Evaluated for possible dialysis'
    },
    extras: { mdiQuestionId: 'ea3b794c-90f2-4659-bffc-2157a808594a' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_usedPast3Months',
    label: 'Have you used any of the following in the past 3 months?',
    type: 'select',
    educationalSlide:
      'Please note: death can result if ED meds are used in conjunction with certain recreational drugs.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'poppers_or_rush_amyl_nitrate_or_butyl_ni',
          value: 'Poppers or Rush (Amyl Nitrate or Butyl Nitrate)'
        },
        { key: 'cocaine', value: 'Cocaine' },
        {
          key: 'methamphetamine_crystal_meth',
          value: 'Methamphetamine (crystal meth)'
        },
        { key: 'none_of_the_above', value: 'NONE of the above' }
      ]
    },
    extras: { mdiQuestionId: '4ecb7ab6-aedd-42ca-854b-5a33b1bd3349' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_takeMedications',
    label: 'Do you take any of the following medications?',
    type: 'select',
    educationalSlide:
      'Please note: death can result if ED medications are used in conjunction with nitrates (often prescribed for chest pain/angina) or other medications. Please be accurate.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'adempas_riociquat_which_is_used_to_treat',
          value:
            'Adempas (Riociquat), which is used to treat pulmonary hypertension.'
        },
        {
          key: 'alpha_blockers_ex_alfuzolin_terazosin_do',
          value:
            'Alpha blockers (ex: alfuzolin, terazosin, doxazosin, tamsulosin)'
        },
        {
          key: 'cimetidine_erythromycin_or_digitoxin',
          value: 'Cimetidine, Erythromycin, OR Digitoxin'
        },
        {
          key: 'ketoconazole_itraconazole_oral_only_not',
          value: 'Ketoconazole/itraconazole (oral only. NOT topical)'
        },
        { key: 'ritonavir_or_saquinavir', value: 'Ritonavir or Saquinavir' },
        { key: 'trazodone', value: 'Trazodone' },
        { key: 'none_of_the_above', value: 'NONE of the above' }
      ]
    },
    extras: { mdiQuestionId: '16d25586-973e-4f29-8b54-59fdcaec6096' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_everPrescribedNitratesNitroglycerin',
    label: 'Have you ever been prescribed nitrates/nitroglycerin?',
    type: 'select',
    educationalSlide:
      '• Eg: Nitrostat, nitrogard, Imdur, isosorbide dinitrate, isosorbide mononitrate',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '80cd5616-b2b1-4a07-af2a-f6768bea6078' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_provideMuchDetailPossibleLast',
    label:
      'Please provide as much detail as possible.  When was the last time you were prescribed nitrates/nitroglycerine',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionInitial_provideMuchDetailPossibleLast'
    },
    extras: { mdiQuestionId: 'db1688fb-1491-4e9c-bd1d-14ed32b62458' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_vitalsTestedMedicalPractitionerPast',
    label:
      'Have you had your vitals tested by a medical practitioner in the past 3 years?',
    type: 'select',
    educationalSlide: 'This includes weight, blood pressure, and heart rate.',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '4968a49f-c289-4792-ae96-5f5d98776e9b' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_bloodPressureAverageDayEven',
    label:
      'What is your blood pressure on an average day (even when taking medication)?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'normal_110_120mmhg_70_80mmhg',
          value: 'Normal (110-120mmHg/70-80mmHg)'
        },
        {
          key: 'mildly_elevated_121_130mmhg_80_90mmhg',
          value: 'Mildly Elevated (121-130mmHg/80-90mmHg)'
        },
        {
          key: 'elevated_141_160mmhg_90_100mmhg',
          value: 'Elevated (141-160mmHg/90-100mmHg)'
        },
        {
          key: 'severe_elevation_160mmhg_110mmhg',
          value: 'Severe elevation (>160mmHg/110mmHg)'
        },
        {
          key: 'mildly_low_100_110mmhg_65_70mmhg',
          value: 'Mildly low (100-110mmHg/65-70mmHg)'
        },
        { key: 'very_low_95mmhg_65mmhg', value: 'Very low (<95mmHg/<65mmHg)' }
      ]
    },
    extras: { mdiQuestionId: 'd7db9cb2-784a-4fc4-9556-829cf8fd2970' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent  (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionInitial_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: 'd553cd87-3464-40e2-82c1-88d62f3cac82' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_heresFirstMessageDoctorIntroduce',
    label:
      'Here’s your first message to your doctor. Please introduce yourself and feel free to:',
    type: 'info',
    subLabel:
      '• Ask any questions you have\n• List any medical problems you have which were not discussed above.\n• Include anything else you would like the doctor to know.',
    answer: {
      type: 'text',
      name: 'mdiErectileDysfunctionInitial_heresFirstMessageDoctorIntroduce',
      rows: 4
    },
    extras: { mdiQuestionId: '53582b48-c93f-4786-8076-27ee0c5d5310' }
  },
  {
    field: 'mdiErectileDysfunctionInitial_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiErectileDysfunctionInitialAnswerField = Partial<
  QuestionAnswerMap<typeof mdiErectileDysfunctionInitialQuestions>
>;

export default mdiErectileDysfunctionInitialQuestions;
